import React, { useEffect, useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  TextField,
  Divider,
  FormControl,
  RadioGroup,
  FormControlLabel,
  Radio,
  Select,
  MenuItem,
  Autocomplete,
  FormGroup,
  Checkbox,
  IconButton,
  FormHelperText,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import SearchButton from "../../components/search/Search";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import CloudUpload from "../../components/button/Cloudupload";
import { Link, useNavigate } from "react-router-dom";
import { createenquiry } from "../../slices/enquiry";
import { getregion, getuser } from "../../slices/setting";
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import dayjs from 'dayjs';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { AddCircle, RemoveCircle } from '@mui/icons-material';
import { getcities, getcountries, getstates } from "../../slices/country";
import { getproductstock } from "../../slices/inventory";
import { getfinancier } from "../../slices/finance";

const Addenquiry = ({ setLoader, show }) => {

  const [current_fleet_details, setOldVehicle] = useState([
    { name: '', model: '', fuel: '' },
  ]);

  const user = JSON.parse(localStorage.getItem('user'));

  const { countries, staties, cities } = useSelector((state) => state.country);

  const settingData = useSelector((state) => state.setting);

  const {vehicles: vehicleStockData} = useSelector((state) => state.inventory) || [];

  const {financier}= useSelector((state) => state.finance);

  const mergedArray = vehicleStockData?.reduce((acc, curr) => {
    const existingIndex = acc.findIndex(item => item.vehicle.id === curr.vehicle.id && item.variant.id === curr.variant.id);
    if (existingIndex !== -1) {
      acc[existingIndex].stocks.push(curr.stock);
    } else {
      acc.push({ ...curr, stocks: [curr.stock] });
    }
    return acc;
  }, []);


  const vechileModel = mergedArray?.map((va)=>{
    return{
      product_img: va?.vehicle?.product_img,
      product_name: va?.vehicle?.product_name,
      variant_name: va?.variant?.variant_name,
      colours: va?.variant?.color_details && JSON.parse(va?.variant?.color_details)?.map(obj => obj?.code),
      stocks: va?.stocks?.length,
      registration_type: va?.vehicle?.registration,
      subsidy: va?.variant?.subsidy
    }
  });

  console.log("countries", vechileModel, mergedArray)

  const validationSchema = Yup.object({
    sales_person: Yup.string().required("Sales Person is required"),
    sale_type: Yup.string().required("Sales Type is required"),
    source_of_enquiry: Yup.string().required("Source of Enquiry is required"),
    enquiry_type: Yup.string().required("Enquiry Type is required"),
    customer_type: Yup.string().required("Customer Type is required"),
    first_name: Yup.string().required("First Name is required"),
    last_name: Yup.string().required("Last Name is required"),
    phone: Yup.string().required("Phone Number is required"),
    gst_number: Yup.string().when('customer_type', {
  is: (val) => val === 'Business',
  then: () => Yup.string().required('GST Number is required'),
  otherwise: () => Yup.string().notRequired(),
}),
    address: Yup.string().required("Address 1 is required"),
    address_one: Yup.string().required("Address 2 is required"),
    pincode: Yup.string().required("Pin Code is required"),
    locality: Yup.string().required("Locality is required"),
    city: Yup.string().required("City is required"),
    state: Yup.string().required("State is required"),
    country: Yup.string().required("Country is required"),
    payment_type: Yup.string().required("Payment Type is required"),
  });

  const formik = useFormik({
  initialValues: {
  dealer_id: user.dealer_id,
  sale_type: "",
  enquiry_date: dayjs(),
  enquiry_status: "New",
  enquiry_type: "",
  sales_person: "",
  source_of_enquiry: "",
  customer_id: "None",
  customer_type: "Individual",
  title: "Mr",
  first_name: "",
  last_name: "",
  middle_name: "",
  phone: "",
  so_wo_do_first_name: "None",
  so_wo_do_middle_name: "",
  so_wo_do_last_name: "None",
  tel_number: "",
  email: "",
  address: "",
  address_one: "",
  pincode: "",
  locality: "",
  tehsil: "None",
  city: "",
  state: "",
  country: "",
  finance_required: false,
  payment_type:"Cash",
  loan_amount:"",
  financier: "",
  photo_url: "",
  vehicle_details: {
    model_code:"",
    model_desc:"",
    model_color:"",
    qty:""
  },
  schedule: dayjs(),
  fp_action: "",
  subject : "",
  note: "",
  current_fleet_details,
  created_by:user.organization_name,
  alt_phone:"",
  gst_number:"",
  previous_schedules:[]
  },
    validationSchema,
    onSubmit: (values) => {
      console.log('Form Data:', values);
    setLoader(true)
    dispatch(createenquiry({...values, enquiry_date: (values.enquiry_date).format('YYYY-MM-DD HH:mm:ss'), schedule: (values.schedule).format('YYYY-MM-DD HH:mm:ss'), phone: String(values.phone), alt_phone: String(values.alt_phone)}))
    .then(() => {
      navigate("/enquiry");
      setLoader(false);
    })
    .catch(()=>{
      setLoader(false);
    })
    },
  });

  const handleAddOldVehicle = () => {
    formik.setFieldValue('current_fleet_details', [
      ...formik.values.current_fleet_details,
      { name: '', model: '', fuel: ''},
    ]);
  };

  const handleRemoveOldVehicle = (index) => {
    const updatedVehicle = [...formik.values.current_fleet_details];
    updatedVehicle.splice(index, 1);
    formik.setFieldValue('current_fleet_details', updatedVehicle);
  };

  const dispatch = useDispatch();

  const navigate = useNavigate();

  const arrowBack = () => {
    navigate(-1);
  };

  useEffect(() => {
    dispatch(getcountries());
    dispatch(getuser());
    dispatch(getproductstock());
    dispatch(getfinancier())
  }, []);

  // const handleSubmit = (e) => {
  //   e.preventDefault();

  //   setLoader(true)

  //   dispatch(createenquiry({...enquirydata, schedule: (enquirydata.schedule).format('YYYY-MM-DD HH:mm:ss')}))
  //   .then(() => {
  //     navigate("/enquiry");
  //     setLoader(false);
  //   })
  //   .catch(()=>{
  //     setLoader(false);
  //   })
  // };

  return (
    <div className="content" style={{ marginLeft: show ? "220px" : "10px" }}>
      <Box  component="form"
    noValidate
    autoComplete="off"
    onSubmit={formik.handleSubmit}>
        <Grid container spacing={3} sx={{ paddingBottom: 2 }}>
          <Grid
            item
            xs={12}
            sx={{
              paddingTop: 0,
              display: "flex",
              alignItems: "center",
              gap: 2,
            }}
          >

            <ArrowBackIcon onClick={arrowBack} sx={{ cursor: "pointer" }} />
            <Typography variant="h5" sx={{fontWeight:'bold'}}>New Enquire</Typography>
          </Grid>
          <Grid item xs={3}>
                                <Typography >Enquiry Date & Time *</Typography>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DemoContainer components={['MobileDateTimePicker']}>
                        <DateTimePicker 
                        readOnly
                        format="LLL" 
                        onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'enquiry_date', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('enquiry_date', "Invalid date");
      }
    }}
                        name="enquiry_date"
                        value={formik.values.enquiry_date}
                      onBlur={formik.handleBlur}
                      error={formik.touched.enquiry_date && Boolean(formik.errors.enquiry_date)}
                      helperText={formik.touched.enquiry_date && formik.errors.enquiry_date}
                        />
                      </DemoContainer>
                    </LocalizationProvider>
            </Grid>
            <Grid item xs={3}>
                <Typography mb={1}>Sales Person *</Typography>
                 <FormControl size="small" fullWidth>
                                         <Select
                                           labelId="demo-simple-select-label"
                                           id="demo-simple-select"
                                           name="sales_person"
                                           value={formik.values.sales_person}
                                           onChange={(newValue) => {
                      formik.setFieldValue( 'sales_person', newValue.target.value);
                    }}
                                    onBlur={formik.handleBlur}
                                 
                                                 >
                                                 {settingData?.user?.filter(ab => ab.user_role === "Sales Person").map((va, index)=>(
                                                  <MenuItem key={index} value={`${va.first_name}${va.last_name}`}>{va.first_name}{va.last_name}</MenuItem>
                                                 ))}
                                         </Select>
                                         {formik.touched.enquiry_no && formik.errors.enquiry_no && (
                    <FormHelperText error={formik.touched.enquiry_no && Boolean(formik.errors.enquiry_no)}>{formik.errors.enquiry_no}</FormHelperText>
                  )}
                                         </FormControl>     
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Sale Type *</Typography>
                   <FormControl size="small" fullWidth>
                         <Select
                           labelId="demo-simple-select-label"
                           id="demo-simple-select"
                           name="sale_type"
                           value={formik.values.sale_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                 
                                 >
                        <MenuItem value="Sale Delivery">Sale Delivery</MenuItem>
                                         <MenuItem value="Sale">Sale</MenuItem>
                                         <MenuItem value="Service">Service</MenuItem>
                         </Select>
                         {formik.touched.sale_type && formik.errors.sale_type && (
    <FormHelperText error={formik.touched.sale_type && Boolean(formik.errors.sale_type)}>{formik.errors.sale_type}</FormHelperText>
  )}
                         </FormControl>                              
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Source of Enquiry *</Typography>
                <TextField
                size="small"
                fullWidth
                name="source_of_enquiry"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.source_of_enquiry}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.source_of_enquiry && Boolean(formik.errors.source_of_enquiry)}
                    helperText={formik.touched.source_of_enquiry && formik.errors.source_of_enquiry}
                    onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
                    />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Enquiry Type *</Typography>
                <FormControl fullWidth>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="enquiry_type"
                  value={formik.values.enquiry_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.enquiry_type && Boolean(formik.errors.enquiry_type)}
                    helperText={formik.touched.enquiry_type && formik.errors.enquiry_type}
                >
                  <FormControlLabel
                    value="HOT"
                    control={<Radio />}
                    label="HOT"
                  />
                  <FormControlLabel
                    value="COLD"
                    control={<Radio />}
                    label="COLD"
                  />
                  <FormControlLabel
                    value="WARM"
                    control={<Radio />}
                    label="WARM"
                  />
                </RadioGroup>
                {formik.touched.enquiry_type && formik.errors.enquiry_type && (
    <FormHelperText error={formik.touched.enquiry_type && Boolean(formik.errors.enquiry_type)}>{formik.errors.enquiry_type}</FormHelperText>
  )}
              </FormControl>
                </Grid>
                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Customer Details</Typography>
          </Grid>
          <Grid item xs={3}>
                <Typography mb={1}>Customer Type *</Typography>
                <FormControl fullWidth>
                <RadioGroup
                  row
                  aria-labelledby="demo-row-radio-buttons-group-label"
                  name="customer_type"
                  value={formik.values.customer_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                  <FormControlLabel
                    value="Business"
                    control={<Radio />}
                    label="Business"
                  />
                  <FormControlLabel
                    value="Individual"
                    control={<Radio />}
                    label="Individual"
                  />
                </RadioGroup>
                {formik.touched.customer_type && formik.errors.customer_type && (
    <FormHelperText error={formik.touched.customer_type && Boolean(formik.errors.customer_type)}>{formik.errors.customer_type}</FormHelperText>
  )}
              </FormControl>
                </Grid>
                <Grid item xs={6}>
                <Typography mb={1}>Full Name *</Typography>
                <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  gap: 1
                }}
              >
                <FormControl size="small"  sx={{ minWidth: 80 }}>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    name="title"
                    value={formik.values.title}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.title && Boolean(formik.errors.title)}
                    helperText={formik.touched.title && formik.errors.title}
                  >
                    <MenuItem selected value="Mr">
                      Mr
                    </MenuItem>
                    <MenuItem value="Miss">Miss</MenuItem>
                    <MenuItem value="Mrs">Mrs</MenuItem>
                  </Select>
                </FormControl>{" "}
                <TextField
                   size="small"
                  fullWidth
                  id="outlined-basic"
                  placeholder="First Name"
                  name="first_name"
                  variant="outlined"
                  value={formik.values.first_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                    helperText={formik.touched.first_name && formik.errors.first_name}
                    onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
                />
                <TextField
                   size="small"
                  fullWidth
                  id="outlined-basic"
                  placeholder="Last Name"
                  name="last_name"
                  variant="outlined"
                  value={formik.values.last_name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                    helperText={formik.touched.last_name && formik.errors.last_name}
                    onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
                />
              </Box>
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Phone Number *</Typography>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="phone"
                value={formik.values.phone}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.phone && Boolean(formik.errors.phone)}
                helperText={formik.touched.phone && formik.errors.phone}
                type="number"
                  onInput={(e) => {
                e.target.value = e.target.value.slice(0, 10);
                }}
                onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      MozAppearance: 'textfield', // For Firefox
    },
  }}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Alt Number</Typography>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                variant="outlined"
                name="alt_phone"
                value={formik.values.alt_phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    type="number"
                      onInput={(e) => {
                    e.target.value = e.target.value.slice(0, 10);
                  }}
                  onKeyDown={(e) => {
                    if (["e", "E", "+", "-", "."].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  sx={{
    '& input[type="number"]::-webkit-outer-spin-button, & input[type="number"]::-webkit-inner-spin-button': {
      WebkitAppearance: 'none',
      margin: 0,
    },
    '& input[type="number"]': {
      MozAppearance: 'textfield', // For Firefox
    },
  }}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Email ID</Typography>
                <TextField
                type="email"
                size="small"
                fullWidth
                name="email"
                id="outlined-basic"
                placeholder="test@gmail.com"
                variant="outlined"
                value={formik.values.email}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
              />
                </Grid>
                {formik.values.customer_type === "Business" ?
                <>
                <Grid item xs={3}>
                <Typography mb={1}>GST Number *</Typography>
                <TextField
                size="small"
                fullWidth
                name="gst_number"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.gst_number}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.gst_number && Boolean(formik.errors.gst_number)}
                    helperText={formik.touched.gst_number && formik.errors.gst_number}
              />
                </Grid>
                              </>
              :
              <>
              <Grid item xs={3}>
                </Grid>
              </>
                }

                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Address & Payment Details</Typography>
          </Grid>
          <Grid item xs={3}>
                <Typography mb={1}>Address 1 *</Typography>
                <TextField
                size="small"
                fullWidth
                id="outlined-basic"
                name="address"
                variant="outlined"
                value={formik.values.address}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.address && Boolean(formik.errors.address)}
                    helperText={formik.touched.address && formik.errors.address}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Address 2 *</Typography>
                <TextField
                size="small"
                fullWidth
                name="address_one"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.address_one}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.address_one && Boolean(formik.errors.address_one)}
                    helperText={formik.touched.address_one && formik.errors.address_one}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Pin Code *</Typography>
                <TextField
                size="small"
                fullWidth
                name="pincode"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.pincode}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.pincode && Boolean(formik.errors.pincode)}
                    helperText={formik.touched.pincode && formik.errors.pincode}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Locality *</Typography>
                <TextField
                size="small"
                fullWidth
                name="locality"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.locality}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.locality && Boolean(formik.errors.locality)}
                    helperText={formik.touched.locality && formik.errors.locality}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Country *</Typography>
                <Autocomplete
  size="small"
  disablePortal
  id="combo-box-demo"
  options={countries || []}
  value={countries.filter(va => va.name === formik.values.country)[0] || null}
  getOptionLabel={(option) => option.name}
  onChange={(event, value) => {
    formik.setFieldValue('country', value?.name);
    dispatch(getstates(value?.name));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select Country"
      name="country"
      onBlur={formik.handleBlur}
      error={formik.touched.country && Boolean(formik.errors.country)}
      helperText={formik.touched.country && formik.errors.country}
    />
  )}
/>

                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>State *</Typography>
                <Autocomplete
                sx={{p: 0}}
  size="small"
  disablePortal
  id="combo-box-demo"
  options={staties || []}
  value={staties?.filter(va => va.name === formik.values.state)[0] || null}
  getOptionLabel={(option) => option.name}
  onChange={(event, value) => {
    formik.setFieldValue('state', value.name);
    const paydata = {
    "country": formik.values.country,
    "state": value.name
    }

    dispatch(getcities(paydata));
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select State"
      name="state"
      onBlur={formik.handleBlur}
      error={formik.touched.state && Boolean(formik.errors.state)}
      helperText={formik.touched.state && formik.errors.state}
    />
  )}
/>

                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>City *</Typography>
                <Autocomplete
  size="small"
  disablePortal
  id="combo-box-demo"
  options={cities || []}
  value={formik.values.city || null}
  getOptionLabel={(option) => option}
  onChange={(event, value) => {
    formik.setFieldValue('city', value);
  }}
  renderInput={(params) => (
    <TextField
      {...params}
      placeholder="Select City"
      name="city"
      onBlur={formik.handleBlur}
      error={formik.touched.city && Boolean(formik.errors.city)}
      helperText={formik.touched.city && formik.errors.city}
    />
  )}
/>

                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Payment Type *</Typography>
                <FormControl size="small" fullWidth>
                         <Select
                           labelId="demo-simple-select-label"
                           id="demo-simple-select"
                           name="payment_type"
                           value={formik.values.payment_type}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                 
                                 >
                        <MenuItem value="Cash">Cash</MenuItem>
                          <MenuItem value="Loan">Loan</MenuItem>
                         </Select>
                         {formik.touched.payment_type && formik.errors.payment_type && (
    <FormHelperText error={formik.touched.payment_type && Boolean(formik.errors.payment_type)}>{formik.errors.payment_type}</FormHelperText>
  )}
                         </FormControl> 
                </Grid>
                {formik.values.payment_type !== "Cash" &&
                <>
                <Grid item xs={3}>
                <Typography mb={1}>Financiar Name *</Typography>
                <FormControl size="small" fullWidth>
                                         <Select
                                           labelId="demo-simple-select-label"
                                           id="demo-simple-select"
                                           name="sales_person"
                                           value={formik.values.sales_person}
                                           onChange={(newValue) => {
                      formik.setFieldValue( 'sales_person', newValue.target.value);
                    }}
                                    onBlur={formik.handleBlur}
                                 
                                                 >
                                                 {financier.map((va, index)=>(
                                                  <MenuItem key={index} value={va?.financier_name}>{va.financier_name}</MenuItem>
                                                 ))}
                                         </Select>
                                         {formik.touched.enquiry_no && formik.errors.enquiry_no && (
                    <FormHelperText error={formik.touched.enquiry_no && Boolean(formik.errors.enquiry_no)}>{formik.errors.enquiry_no}</FormHelperText>
                  )}
                                         </FormControl>     
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Loan Amount *</Typography>
                <TextField
                size="small"
                fullWidth
                name="loan_amount"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.loan_amount}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.loan_amount && Boolean(formik.errors.loan_amount)}
                    helperText={formik.touched.loan_amount && formik.errors.loan_amount}
                    onBeforeInput={(e) => {
                          if (!/^[0-9\s]*$/.test(e.data)) {
                            e.preventDefault();
                          }
                        }}
              />
                </Grid>
                </>
                }
                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Vehicle Details</Typography>
          </Grid>
          <Grid item xs={3}>
                <Typography mb={1}>Model Code *</Typography>
                <FormControl size="small" fullWidth>
                                         <Select
                                           labelId="demo-simple-select-label"
                                           id="demo-simple-select"
                                           name="model_code"
                                           value={formik.values.model_code}
                                           onChange={(newValue) => {
                      formik.setFieldValue( 'model_code', newValue.target.value);
                      formik.setFieldValue( 'model_desc', vechileModel?.filter(ab => ab.product_name === newValue.target.value)[0]?.variant_name);
                    }}
                                    onBlur={formik.handleBlur}
                                 
                                                 >
                                                 {vechileModel?.map((va, index)=>(
                                                  <MenuItem key={index} value={va?.product_name}>{va.product_name}</MenuItem>
                                                 ))}
                                         </Select>
                                         {formik.touched.model_code && formik.errors.model_code && (
                    <FormHelperText error={formik.touched.model_code && Boolean(formik.errors.model_code)}>{formik.errors.model_code}</FormHelperText>
                  )}
                                         </FormControl> 
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Model Desc *</Typography>
                <TextField
                size="small"
                fullWidth
                name="model_desc"
                id="outlined-basic"
                variant="outlined"
                value={formik.values?.model_desc}
                  onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched?.model_desc && Boolean(formik.errors?.model_desc)}
                    helperText={formik.touched?.model_desc && formik.errors?.model_desc}
              />
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Model Colour *</Typography>
                <FormControl size="small" fullWidth>
                                         <Select
                                           labelId="demo-simple-select-label"
                                           id="demo-simple-select"
                                           name="model_color"
                                           value={formik.values.model_color}
                                           onChange={(newValue) => {
                      formik.setFieldValue( 'model_color', newValue.target.value);
                    }}
                                    onBlur={formik.handleBlur}
                                 
                                                 >
                                                 {vechileModel.filter(ab => ab.product_name === formik.values.model_code)[0]?.colours?.map((va, index)=>(
                                                  <MenuItem key={index} value={va}>{va}</MenuItem>
                                                 ))}
                                         </Select>
                                         {formik.touched.model_code && formik.errors.model_code && (
                    <FormHelperText error={formik.touched.model_code && Boolean(formik.errors.model_code)}>{formik.errors.model_code}</FormHelperText>
                  )}
                                         </FormControl> 
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Qty *</Typography>
                <TextField
                size="small"
                fullWidth
                name="vehicle_details.qty"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.vehicle_details?.qty}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.vehicle_details?.qty && Boolean(formik.errors.vehicle_details?.qty)}
                    helperText={formik.touched.vehicle_details?.qty && formik.errors.vehicle_details?.qty}
              />
                </Grid>
                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Follow Ups</Typography>
          </Grid>
          <Grid item xs={3}>
                <Typography >Next Follow Up Date *</Typography>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
      <DemoContainer components={['MobileDateTimePicker']}>
        <DateTimePicker  
          name="schedule"
          format="LLL"
           value={formik.values.schedule || null}
           onChange={(newValue) => {
      const formattedDate = dayjs(newValue);
      formik.setFieldValue( 'schedule', formattedDate);
    }}
    onError={(reason) => {
      if (reason) {
        formik.setFieldError('schedule', "Invalid date");
      }
    }}
                    onBlur={formik.handleBlur}
                    error={formik.touched.schedule && Boolean(formik.errors.schedule)}
                    helperText={formik.touched.schedule && formik.errors.schedule}
        />
      </DemoContainer>
    </LocalizationProvider>
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Action *</Typography>
                <FormControl size="small" fullWidth>
                         <Select
                           labelId="demo-simple-select-label"
                           id="demo-simple-select"
                           name="fp_action"
                           value={formik.values.fp_action}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                                 >
                        <MenuItem value="Visit">Visit</MenuItem>
                          <MenuItem value="Meeting">Meeting</MenuItem>
                         </Select>
                         {formik.touched.fp_action && formik.errors.fp_action && (
    <FormHelperText error={formik.touched.fp_action && Boolean(formik.errors.fp_action)}>{formik.errors.fp_action}</FormHelperText>
  )}
                         </FormControl> 
                </Grid>
                <Grid item xs={3}>
                <Typography mb={1}>Subject *</Typography>
                <TextField
                size="small"
                fullWidth
                name="subject"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.subject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.subject && Boolean(formik.errors.subject)}
                    helperText={formik.touched.subject && formik.errors.subject}
                    onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
              />
                </Grid>
                
                <Grid item xs={3}>
                <Typography mb={1}>Remarks *</Typography>
                <TextField
                size="small"
                fullWidth
                name="note"
                id="outlined-basic"
                variant="outlined"
                value={formik.values.note}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.note && Boolean(formik.errors.note)}
                    helperText={formik.touched.note && formik.errors.note}
                    onBeforeInput={(e) => {
                      if (!/^[a-zA-Z\s]*$/.test(e.data)) {
                              e.preventDefault();
                        }
                      }}
              />
                </Grid>
                <Grid item xs={12}>
            <Typography variant="h6" component="h6" sx={{fontWeight:'600', background:'lightgrey', p: 1}}>Old Vehicle Details</Typography>
          </Grid>
          <Grid item xs={12}>
          {formik.values.current_fleet_details.map((vechile, index) => (
            <Grid container spacing={2} marginBottom={2} alignItems={'center'}>
            <Grid item xs={4}>
                <TextField
                size="small"
                fullWidth
                placeholder="Vehicle Name"
                id="outlined-basic"
                variant="outlined"
                name={`current_fleet_details[${index}].name`}
                      value={vechile.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.name &&
                        Boolean(formik.errors.current_fleet_details?.[index]?.name)
                      }
                      helperText={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.name &&
                        formik.errors.current_fleet_details?.[index]?.name
                      }
              />
                </Grid>
                <Grid item xs={4}>
                <TextField
                size="small"
                fullWidth
                placeholder="Vehicle Model"
                id="outlined-basic"
                variant="outlined"
                name={`current_fleet_details[${index}].model`}
                      value={vechile.model}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.model &&
                        Boolean(formik.errors.current_fleet_details?.[index]?.model)
                      }
                      helperText={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.model &&
                        formik.errors.current_fleet_details?.[index]?.model
                      }
              />
                </Grid>
                
                <Grid item xs={3}>
                <TextField
                size="small"
                fullWidth
                placeholder="Type of Fuel"
                id="outlined-basic"
                variant="outlined"
                name={`current_fleet_details[${index}].fuel`}
                      value={vechile.fuel}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      error={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.fuel &&
                        Boolean(formik.errors.current_fleet_details?.[index]?.fuel)
                      }
                      helperText={
                        formik.touched.current_fleet_details &&
                        formik.touched.current_fleet_details[index]?.fuel &&
                        formik.errors.current_fleet_details?.[index]?.fuel
                      }
              />
                </Grid>
                
                <Grid item xs={1}>
                <Button
                      variant="outlined"
                      color="error"
                      onClick={() => handleRemoveOldVehicle(index)}
                    >
                      <RemoveCircle />
                    </Button>
                </Grid>
            </Grid>
          ))}
          <Button
          sx={{marginTop: 2}}
                  variant="contained"
                  color="success"
                  startIcon={<AddCircle />}
                  onClick={handleAddOldVehicle}
                >
                  Add Another Vehicle
                </Button>
          </Grid>
        </Grid>
            <Grid container spacing={2}>
                <Grid item xs={12} sx={{textAlign:'end'}}>
                  <Button sx={{mr: 2}} onClick={arrowBack} variant="outlined">Cancel</Button>
                  <Button type="submit" variant="contained">Create Enquiry</Button>
                </Grid>
            </Grid>
      </Box>
    </div>
  );
};

export default Addenquiry;
